import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import getAppointmentCartByUid from 'Common/functions/getAppointmentCartByUid';
import { AppCookie, getCookie, setCookie } from './Cookie';
import getOrInitializeAppointmentCart from './getOrInitializeAppointmentCart';

export const getAppointmentCart = async (
  client: ApolloClient<NormalizedCacheObject>,
  appointmentCartUid: string | undefined,
) => {
  if (!appointmentCartUid) {
    return;
  }

  const cart = await getAppointmentCartByUid(
    client.query,
    undefined,
    appointmentCartUid,
    'no-cache',
  );

  if (cart) {
    return cart;
  }
};

export const getAppointmentCartUidMap = () => {
  const appointmentCartUidMap = getCookie(AppCookie.CustomerAppointmentCartUidMap);
  if (appointmentCartUidMap) {
    return JSON.parse(appointmentCartUidMap);
  }

  return {};
};

export const getAppointmentCartUid = (map: Record<string, string>, serviceProviderId: string) => {
  const appointmentCartUid = map[serviceProviderId];
  if (appointmentCartUid) {
    return appointmentCartUid;
  }
  return null;
};

export const getOrInitializeAppointmentCartUid = async (
  mutate: ApolloClient<object>['mutate'],
  appointmentCartUid: string | undefined,
  serviceProviderUid: string,
) => {
  if (appointmentCartUid) {
    return appointmentCartUid;
  }

  const cart = await getOrInitializeAppointmentCart(
    mutate,
    undefined,
    serviceProviderUid,
  );
  if (!cart) {
    return null;
  }

  return cart.uid;
};

export const ensureAppointmentCartCookieClientSide = (
  serviceProviderId: string,
  currentCookieValue: string | undefined,
  nextCookieValue: string,
) => {
  if (nextCookieValue !== currentCookieValue) {
    const appointmentCartMap = {
      [serviceProviderId]: nextCookieValue,
    };
    setCookie(
      AppCookie.CustomerAppointmentCartUidMap,
      JSON.stringify(appointmentCartMap),
    );
  }
};

